// Variations of the existing gold (#E8AA68) — brighter / sharper / more saturated —
// shown on BOTH light (cream) and dark (espresso) backgrounds so one value can work everywhere.

const PHRASE = "Agentic Alpha";

const VARIATIONS = [
  { id: "0", name: "Current", hex: "#E8AA68", desc: "The existing gold. Soft and warm — great on dark, a little pale on light." },
  { id: "1", name: "Warm Gold", hex: "#E7A24E", desc: "Slightly more saturated and a touch deeper. Keeps the soft warmth, reads a bit better on light." },
  { id: "2", name: "Amber Gold", hex: "#EDA13A", desc: "Noticeably sharper and punchier. Strong presence on both backgrounds." },
  { id: "3", name: "Marigold", hex: "#F2A93C", desc: "Brighter and more vivid — the most prominent option while still gold." },
  { id: "4", name: "Deep Gold", hex: "#DE9A2E", desc: "Deeper, more saturated. Best legibility on light; still glows on dark." },
  { id: "5", name: "Honey Amber", hex: "#E39A34", desc: "Balanced middle-ground: sharp on light, rich on dark." },
];

const Sample = ({ hex, dark }) => (
  <div
    className={`flex-1 rounded-xl border p-5 flex flex-col justify-center min-h-[132px] ${
      dark ? "bg-[#211307] border-white/10" : "bg-[#F7F5F0] border-[#3E2818]/10"
    }`}
  >
    <span className={`font-mono2 text-[9px] uppercase tracking-[0.22em] mb-2 ${dark ? "text-white/40" : "text-[#3E2818]/40"}`}>
      {dark ? "Dark background" : "Light background"}
    </span>
    <p className={`font-display font-medium tracking-tight text-2xl lg:text-[1.9rem] leading-tight ${dark ? "text-[#F7F5F0]" : "text-[#3E2818]"}`}>
      Achieve <span className="italic" style={{ color: hex }}>{PHRASE}</span>
    </p>
  </div>
);

export default function AAOptions() {
  return (
    <div className="min-h-screen bg-white text-[#3E2818]">
      <div className="max-w-5xl mx-auto px-6 py-14">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#8A5730]">Gold Variations · Light &amp; Dark</p>
        <h1 className="font-display text-2xl lg:text-3xl font-medium mt-2 tracking-tight">Sharper variations of the gold</h1>
        <p className="text-sm text-[#3E2818]/60 mt-3 max-w-2xl leading-relaxed">
          Each row is a variation of the current gold, rendered on both backgrounds. Pick the one that stays prominent on light while still
          looking great on dark, then tell me the number and I&rsquo;ll apply it site-wide.
        </p>

        <div className="mt-10 space-y-5">
          {VARIATIONS.map((v) => (
            <div key={v.id} data-testid={`gold-variation-${v.id}`}>
              <div className="flex items-baseline gap-3 mb-2">
                <span className="font-mono2 text-[11px] uppercase tracking-[0.22em] text-[#8A5730]">
                  {v.id === "0" ? v.name : `Variation ${v.id} · ${v.name}`}
                </span>
                <span className="font-mono2 text-[11px] text-[#3E2818]/45">{v.hex}</span>
                <span className="inline-block w-4 h-4 rounded-full border border-black/10" style={{ backgroundColor: v.hex }} />
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <Sample hex={v.hex} dark={false} />
                <Sample hex={v.hex} dark />
              </div>
              <p className="text-[12px] text-[#3E2818]/55 mt-2 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
